export const NEW_QUOTE_REQUEST = "NEW_QUOTE_REQUEST";
export const CLOSE_QUOTE_FORM = 'CLOSE_QUOTE_FORM';
export const QUOTE_REQUEST = "QUOTE_REQUEST";
export const QUOTE_SUCCESS = "QUOTE_SUCCESS";
export const QUOTE_FAILURE = "QUOTE_FAILURE";

export function newQuoteBookingRequest() {
    return { type: NEW_QUOTE_REQUEST };
}

export function closeQuoteBookingForm() {
    return { type: CLOSE_QUOTE_FORM };
}


function quoteRequest() {
  return {
    type: QUOTE_REQUEST
  }
};

function quoteSuccess(data) {
  return {
    type: QUOTE_SUCCESS,
    payload: data.res
  }
};

function quoteFailure(error) {
  return {
    type: QUOTE_FAILURE,
    payload: error
  }
};